import { useTranslation } from "react-i18next";
import Select from "../../../../../parts/inputs/select";
import { getInsightsLensOptions } from "../../../../../utils/insights-lens";
import { SectionLabel } from "./SectionLabel";

/**
 * The Progress Overview focus a PUSH subscriber starts with until they pick their own. Empty =
 * no default: the app asks the subscriber.
 */
export const TrainingFocusCard = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation("dashboard");
  const title = t("pushDailyDashboard.trainingFocus.title");
  const noDefaultLabel = t("pushDailyDashboard.trainingFocus.none");

  return (
    <>
      <SectionLabel label={t("pushDailyDashboard.progress")} />
      <div className="push-dd-tile">
        <div className="push-dd-tile__text">
          <p className="push-dd-tile__title">{title}</p>
          <p className="push-dd-tile__sub">
            {t("pushDailyDashboard.trainingFocus.description")}
          </p>
        </div>
        {/* Not saved under its own name: the section's hidden payload carries it */}
        <Select
          name="pushDashboardTrainingFocus"
          options={[
            { value: "", label: noDefaultLabel },
            ...getInsightsLensOptions(t),
          ]}
          value={value}
          // Select only finds the "No default" option for an exact "", so a
          // missing or null value would otherwise render an empty control.
          displayLabel={value ? undefined : noDefaultLabel}
          onChange={onChange}
          disabled={false}
          alignRight
        />
      </div>
    </>
  );
};
